export enum AuthType {
    TokenExpired = 'tokenExpired',
    TokenProvided = 'tokenProvided',
}

export interface TokenExpiredAction {
    type: AuthType.TokenExpired;
}

export interface TokenProvidedAction {
    type: AuthType.TokenProvided;
    token: string;
    url: string;
}

export const tokenExpired = (): TokenExpiredAction => ({
    type: AuthType.TokenExpired,
});

export const tokenProvided = (token: string, url: string): TokenProvidedAction => ({
    type: AuthType.TokenProvided,
    token,
    url,
});

export type AuthActionTypes = TokenExpiredAction | TokenProvidedAction;
